import {
    GET_GAME_REQUEST,
    GET_GAME_SUCCESS,
    GET_GAME_FAILURE,
    GET_HOTS_REQUEST,
    GET_HOTS_SUCCESS,
    GET_HOTS_FAILURE,
    GET_CHALLENGE_REQUEST,
    GET_CHALLENGE_SUCCESS,
    GET_CHALLENGE_FAILURE,
} from '../constant/actionTypes';

const initState = {
    gid: "",
    title: "",
    subTitle: "",
    imgUrl: "",
    host: "",
    type: "",
    goal: "",
    rewardType: "",
    reward: "",
    startRegister: 0,     // ttm
    endRegister: 0,       // etm
    dueDay: 0,
    price: 0,
    startTime: 0,
    endTime: 0,
    duration: 0,
    rule: "",
    leaders: [],
    meta: [],
    isLoading: true,
    pageNotFound: false,
    hots: {},
    challenge: {},
}

const game = (state = initState, action) => {
    switch (action.type) {
        case GET_GAME_SUCCESS:
            return {
                ...state,
                gid: action.payload.gid,
                title: action.payload.title,
                subTitle: action.payload.subTitle,
                imgUrl: action.payload.imgUrl,
                host: action.payload.host,
                type: action.payload.type,
                goal: action.payload.goal,
                rewardType: action.payload.rewardType,
                reward: action.payload.reward,
                startRegister: action.payload.ttm,
                endRegister: action.payload.etm,
                dueDay: action.payload.dueDay,
                price: action.payload.price,
                startTime: action.payload.startTime,
                endTime: action.payload.endTime,
                duration: action.payload.duration,
                rule: action.payload.rule,
                leaders: action.payload.leaders,
                meta: action.payload.meta,
                tags: action.payload.tags,
                task: action.payload.task,
                taskImgUrl: action.payload.taskImgUrl,
                ruleImgUrl: action.payload.ruleImgUrl,
                isLoading: false,
            }
        case GET_GAME_FAILURE:
            return {
                ...state,
                pageNotFound: true,
            }
        case GET_HOTS_SUCCESS:
            return {
                ...state,
                hots: {
                    ...state.hots,
                    ...action.payload,
                },
                isLoading: false,
            }
        case GET_HOTS_FAILURE:
            return {
                ...state,
            }
        case GET_CHALLENGE_SUCCESS:
            return {
                ...state,
                challenge: {
                    ...state.challenge,
                    ...action.payload,
                }
            }
        case GET_CHALLENGE_FAILURE:
            return {
                ...state,
            }
        case GET_GAME_REQUEST:
        case GET_HOTS_REQUEST:
        case GET_CHALLENGE_REQUEST:
        default:
            return {
                ...state,
            }
    }
};

export default game;